//#region src/dataLayer.ts
var e = "gtmEvent", t = (t, n) => {
	if (typeof window < "u") {
		let r = window.iframeGZContext;
		if (r && r.consentGranted !== !0) return;
		let i = Object.fromEntries(Object.entries(n).filter(([e, t]) => t !== void 0)), a = {
			event: t,
			eventLabel: n.eventLabel ?? "",
			...i
		};
		window.dataLayer = window.dataLayer || [], window.dataLayer.push(a);
		let o = window.parentIFrame;
		o && o.sendMessage({
			type: e,
			data: a
		});
	}
};
//#endregion
export { t as trackEvent };
